import React from 'react';

const DownloadIcon = ({ width = 20, height = 20, color = '#000' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.1835 40.1624C37.1239 40.1624 39.5625 37.7954 39.5625 34.8488V30.2545H36.8355V34.8488C36.8355 36.2472 35.6602 37.4353 34.1835 37.4353L14.1061 37.4353C12.6294 37.4353 11.4541 36.2472 11.4541 34.8487L11.4541 30.2545H8.72705L8.72705 34.8487C8.72705 37.7954 11.1657 40.1624 14.1061 40.1624L34.1835 40.1624Z"
      fill={color}
    />
    <path
      d="M22.7661 7.75471L22.7661 24.7476L16.0349 18.0163C15.4969 17.4784 14.6141 17.4784 14.0762 18.0163C13.5382 18.5543 13.5382 19.4233 14.0762 19.9612L23.1661 29.0511C23.704 29.5891 24.573 29.5891 25.111 29.0511L34.2147 19.975C34.7527 19.437 34.7527 18.5681 34.2147 18.0301C33.6768 17.4922 32.8078 17.4922 32.2698 18.0301L25.5248 24.7476L25.5248 7.75471C25.5248 6.99607 24.9041 6.3758 24.1454 6.3758C23.3868 6.3758 22.7661 6.99607 22.7661 7.75471Z"
      fill={color}
    />
  </svg>
);

export default DownloadIcon;
